import type { AxiosInstance } from 'axios'
import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '@/types/api/results'
import type { City } from '@/types/api/cities'

export function createCitiesModule({
  axios,
  sentry,
}: {
  axios: AxiosInstance
  sentry: any
}) {
  return {
    async fetchCitiesList() {
      try {
        const { data } = await axios.get<City[]>(`cities/`)

        return new Success(data)
      } catch (error: any) {
        switch (error?.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError(
              'fetchCitiesList. Список городов не найден',
            )
          default:
            sentry.captureException(error)
            return new ServerError('fetchCitiesList. Что-то пошло не так')
        }
      }
    },
    async fetchAnalyticsForCommonPage() {
      try {
        const { data } = await axios.get(`ufa/analytics/`)

        return new Success(data)
      } catch (error: any) {
        switch (error?.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError(
              'fetchAnalyticsForCommonPage. Страница не найдена',
            )
          default:
            sentry.captureException(error)
            return new ServerError(
              'fetchAnalyticsForCommonPage. Что-то пошло не так',
            )
        }
      }
    },
  }
}
